module.exports = __webpack_public_path__ + "img/choose.c6134de2.png";